import { ISVG } from "./UrlIcon";

export interface ISortIconProps extends ISVG {}

export const SortIcon = ({ width, height, className }: ISortIconProps) => {
    const _width = width ?? 20;
    const _height = height ?? 15;

    return (
        <svg
            width={_width}
            height={_height}
            viewBox="0 0 20 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className || "fill-black dark:fill-white"}
        >
            <path d="M11.8179 12.9014C12.059 12.9014 12.2903 12.9972 12.4607 13.1677C12.6312 13.3382 12.727 13.5694 12.727 13.8105C12.727 14.0516 12.6312 14.2828 12.4607 14.4533C12.2903 14.6238 12.059 14.7196 11.8179 14.7196H8.18164C7.94054 14.7196 7.70932 14.6238 7.53883 14.4533C7.36835 14.2828 7.27257 14.0516 7.27257 13.8105C7.27257 13.5694 7.36835 13.3382 7.53883 13.1677C7.70932 12.9972 7.94054 12.9014 8.18164 12.9014H11.8179ZM15.4542 6.84093C15.6953 6.84093 15.9265 6.93671 16.097 7.10719C16.2675 7.27768 16.3633 7.5089 16.3633 7.75C16.3633 7.99111 16.2675 8.22233 16.097 8.39282C15.9265 8.5633 15.6953 8.65908 15.4542 8.65908H4.54536C4.30426 8.65908 4.07303 8.5633 3.90255 8.39282C3.73206 8.22233 3.63629 7.99111 3.63629 7.75C3.63629 7.5089 3.73206 7.27768 3.90255 7.10719C4.07303 6.93671 4.30426 6.84093 4.54536 6.84093H15.4542ZM19.0905 0.780457C19.3316 0.780457 19.5628 0.876233 19.7333 1.04672C19.9038 1.2172 19.9996 1.44843 19.9996 1.68953C19.9996 1.93063 19.9038 2.16185 19.7333 2.33234C19.5628 2.50282 19.3316 2.5986 19.0905 2.5986H0.909072C0.667971 2.5986 0.436745 2.50282 0.266261 2.33234C0.0957768 2.16185 0 1.93063 0 1.68953C0 1.44843 0.0957768 1.2172 0.266261 1.04672C0.436745 0.876233 0.667971 0.780457 0.909072 0.780457H19.0905Z" />
        </svg>
    );
};
